﻿function changeSection() {
    window.location = $("#Other_Sections").val();
}

export function setupCarReviewSection() {
    $(document).on("change", "[data-car-review-section] #Other_Sections", changeSection);
}